import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddProductFamily = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onAddProductFamilySubmit,
  categoryList,
  setCatNameForFamily,
  formData,
  isUpdateButton,
  isEditMode,
  setIsUpdateButton,
  setValue
}) => {
  const { content } = categoryList;
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode ? "Add Product Family" : "Edit Product Family"}
              </b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Category-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Category
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Category"
                          name="categoryId"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          {...register("categoryId", { required: true })}
                          defaultValue={formData.categoryId}
                          error={Boolean(errors?.categoryId)}
                          helperText={errors?.categoryId?.message}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {content &&
                            content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.categoryId}
                                  sx={{ width: "100%" }}
                                  value={d.categoryId}
                                  size="small"
                                  onClick={() =>
                                    setCatNameForFamily(d.categoryName)
                                  }
                                >
                                  {d.categoryCode} - {d.categoryName}
                                </MenuItem>
                              );
                            })}        
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.categoryId?.message}
                          </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        name="productFamilyName"
                        label="Product Family Name"
                        placeholder="Enter product family name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("productFamilyName", { required: true })}
                        error={Boolean(errors?.productFamilyName)}
                        helperText={errors?.productFamilyName?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("productFamilyName", str.trim());
                         
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddProductFamilySubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddProductFamily;
  